export type Plan = 'weekly' | 'monthly' | 'annual';

export interface Collective {
  id: string;
  name: string;
  weeklyPrice: number;
  description: string;
  badge: string;
  examples: string[];
}

export interface PriceInput {
  collective: Collective;
  cupsPerDay: number;
  plan: Plan;
  discount?: number;
}

export const DOSES_PER_WEEK_PER_CUP = 7;
export const ADD_ON_CUP_RATE = 0.5;
export const ANNUAL_BREWER_COUPON = 5000;

export function weeklyDoseCount(cupsPerDay: number): number {
  return Math.max(1, cupsPerDay) * DOSES_PER_WEEK_PER_CUP;
}

export function weeklyPriceWithCups(baseWeeklyPrice: number, cupsPerDay: number): number {
  const safeCups = Math.max(1, cupsPerDay);
  return Math.round(baseWeeklyPrice * (1 + (safeCups - 1) * ADD_ON_CUP_RATE));
}

export function planMultiplier(plan: Plan): number {
  if (plan === 'weekly') return 1;
  if (plan === 'monthly') return 4;
  return 42;
}

export function standardAnnualPrice(baseWeeklyPrice: number, cupsPerDay: number): number {
  return weeklyPriceWithCups(baseWeeklyPrice, cupsPerDay) * 52;
}

export function calculateTotal({ collective, cupsPerDay, plan, discount = 0 }: PriceInput): number {
  const subtotal = weeklyPriceWithCups(collective.weeklyPrice, cupsPerDay) * planMultiplier(plan);
  return Math.max(0, subtotal - discount);
}
